export default "__VITE_ASSET__QI$qu3O1__"